export default "__VITE_ASSET__sowqr6c8__"